import React, { Component } from "react";
import Routes from "./Routes";
import { withHeaderFooter, withScroll } from "./HOC";
import { Wrapper } from "./Constant";

class App extends Component {
  render() {
    return (
      // <>
      //   <Wrapper>
      //   </Wrapper>
      // </>
      <Routes />
    );
  }
}

export default withScroll(withHeaderFooter(App));
